import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'components/Icon';
import styles from './CheckBox.module.scss';

const CheckBox = ({ label, checked, disabled, ...props }) => (
  <label className={cn(styles.component, { [styles.disabled]: disabled })}>
    <input type="checkbox" checked={checked} disabled={disabled} {...props} />
    <Icon name={checked ? 'check_box' : 'check_box_outline_blank'} />
    <span>{label}</span>
  </label>
);

CheckBox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};

CheckBox.defaultProps = {
  label: ''
};

export default CheckBox;
